/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface AppointmentClassRoomResponse
 */
export interface AppointmentClassRoomResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof AppointmentClassRoomResponse
     */
    classRoomId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof AppointmentClassRoomResponse
     */
    classRoomName: string;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof AppointmentClassRoomResponse
     */
    locationId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentClassRoomResponse
     */
    locationName: string | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof AppointmentClassRoomResponse
     */
    priority: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the AppointmentClassRoomResponse interface.
 */
export function instanceOfAppointmentClassRoomResponse(value: object): value is AppointmentClassRoomResponse {
    if (!('classRoomId' in value) || value['classRoomId'] === undefined) return false;
    if (!('classRoomName' in value) || value['classRoomName'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    return true;
}

export function AppointmentClassRoomResponseFromJSON(json: any): AppointmentClassRoomResponse {
    return AppointmentClassRoomResponseFromJSONTyped(json, false);
}

export function AppointmentClassRoomResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentClassRoomResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'classRoomId': ApiUserTasksGetPageParameterFromJSON(json['classRoomId']),
        'classRoomName': json['classRoomName'],
        'locationId': ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'locationName': json['locationName'],
        'priority': ApiUserTasksGetPageParameterFromJSON(json['priority']),
    };
}

export function AppointmentClassRoomResponseToJSON(json: any): AppointmentClassRoomResponse {
    return AppointmentClassRoomResponseToJSONTyped(json, false);
}

export function AppointmentClassRoomResponseToJSONTyped(value?: AppointmentClassRoomResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classRoomId': ApiUserTasksGetPageParameterToJSON(value['classRoomId']),
        'classRoomName': value['classRoomName'],
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'locationName': value['locationName'],
        'priority': ApiUserTasksGetPageParameterToJSON(value['priority']),
    };
}

